import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        question: '=',
        form: '=',
        sites: '=',
        metaFieldGroups: '=',
        questionPools: '=',
        backToList: '=',
        backToListWithParams: '='
    },
    template
})

export default class {
    constructor ($rootScope, $scope, $state, $translate, lodash, toastr, Upload,
                 TokenService, QuestionService, QuestionConfirmService, ModalService, ResponseService,
                 QUESTIONS_TYPE_ENUM, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM, QuestionResource) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.Upload = Upload;
        this.TokenService = TokenService;
        this.QuestionService = QuestionService;
        this.QuestionConfirmService = QuestionConfirmService;
        this.ModalService = ModalService;
        this.ResponseService = ResponseService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
        this.QuestionResource = QuestionResource;
        this.tab = 'general';
        const listener = $rootScope.$on('question:reload', () => {
            this.initAnswerValues();
            this.initMatrixValues();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        if (this.question.forms && this.question.forms[0]) {
            this.formType = this.question.forms[0].type;
        }

        this.initMetaFields();

        if (this.form.model.questionAnswers) {
            this.lodash.forEach(this.form.model.questionAnswers, (answer, key) => {
                this.form.model.questionAnswers[key].translations = {};

                this.form.model.questionAnswers[key].translations = this.lodash.reduce(this.form.model.questionAnswersI18ns, (origin, answerI18n) => {
                    if (answerI18n.answerId === answer.id) {
                        if (!origin[answerI18n.language]) {
                            origin[answerI18n.language] = {};
                        }
                        origin[answerI18n.language] = answerI18n;
                    }
                    return origin;
                }, {});
            });
        }

        this.scaleSteps = 3;

        this.initAnswerValues();
        this.initMatrixValues();

        this.chosenFile = null;
        this.chosenFiles = [];
        this.chosenVideoFile = null;
        this.chosenVideoFiles = [];
    }

    initAnswerValues () {
        this.scale = {
            selected: null,
            list: []
        };

        this.matrix = {
            selected: null,
            list: []
        };

        this.models = {
            selected: null,
            list: []
        };

        if (this.form.model.questionAnswers) {
            this.scale.list = [];
            this.scaleSteps = this.form.model.questionAnswers.length;
            this.lodash.forEach(this.form.model.questionAnswers, (item, key) => {
                if (this.isCheckboxOrRadioQuestion()) {
                    this.QuestionService.addItem(this.models);
                }
                else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.SCALE || this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
                    if (this.form.model.questionAnswers[key].correctness === this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE) {
                        this.scaleSteps = this.form.model.questionAnswers.length - 1;
                        this.form.model.allowNAOption = true;
                    }
                    else {
                        this.QuestionService.addScaleValue(this.scale, key + 1, item.text);
                    }
                }
            });

            return;
        }

        this.form.model.questionAnswers = [];
        this.QuestionService.addItem(this.models);

        this.QuestionService.addScaleValue(this.scale, 1, '1');
        this.QuestionService.addScaleValue(this.scale, 2, '2');
        this.QuestionService.addScaleValue(this.scale, 3, '3');
    }

    initMatrixValues () {
        this.matrix.list = [];
        if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
            this.lodash.forEach(this.form.model.childQuestionsActiveI18ns, (childQuestion) => {
                if (childQuestion.language === this.defaultLanguage) {
                    this.QuestionService.addMatrixValue(this.matrix, childQuestion.name);
                }
            });

            return;
        }
        this.QuestionService.addMatrixValue(this.matrix);
    }

    initMetaFields () {
        this.questionMetaFields = {};
        if (!this.form.model.questionMeta) {
            return;
        }
        this.questionMetaFields = this.lodash.reduce(this.form.model.questionMeta, (origin, meta) => {
            if (meta.language !== this.defaultLanguage) {
                return origin;
            }

            if (meta.metaFieldValueId) {
                meta.metaFieldValueId = meta.metaFieldValueId.toString();
            }

            origin[meta.metaFieldId] = meta;
            return origin;
        }, {});
    }

    beforeSave () {
        const questionsMeta = this.lodash.reduce(this.questionMetaFields, (origin, metaField) => {
            metaField.language = this.defaultLanguage;
            origin.push(metaField);
            return origin;
        }, []);

        this.form.model.questionMeta = angular.copy(questionsMeta);

        if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT) {
            delete this.form.model.questionAnswers;
        }
        else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.SCALE) {
            this.form = this.QuestionService.assignScaleFieldsBeforeSave(this.form, this.scale);
        }
        else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
            this.form = this.QuestionService.assignScaleFieldsBeforeSave(this.form, this.scale);
            this.form = this.QuestionService.assignMatrixFieldsBeforeSave(this.form, this.matrix);
        }

        if (this.form.model.type !== this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
            delete this.form.model.childQuestions;
        }

        if (this.form.model.questionAnswers) {
            this.lodash.forEach(this.form.model.questionAnswers, (item, key) => {
                this.form.model.questionAnswers[key].index = key;
            });
        }

        if (!this.isCheckboxOrRadioQuestion() && this.form.model.questionAnswers) {
            this.form.model.questionAnswers = this.form.model.questionAnswers.map(answer => {
                answer.imageFile = null;
                answer.removeImage = true;
                return answer;
            });
        }
    }

    isCheckboxOrRadioQuestion () {
        return this.lodash.includes(
            [this.QUESTIONS_TYPE_ENUM.KEYS.RADIO, this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX],
            this.form.model.type
        );
    }

    save (confirmed = false) {
        this.$rootScope.$broadcast('set.questionSiteIds');

        this.form.errors = {};

        this.beforeSave();

        let uploadUrl = `${SEED_CORE.ENV.API_URL}form/question/${this.form.model.id}`;
        uploadUrl += '?expand=questionI18ns,pool,category,author,questionAnswers,questionMeta,tags,metaGroups,questionAnswersI18ns,' +
        'questionMetaFields,childQuestionsActiveI18ns,childQuestions,forms,sites';
        const method = 'PUT';

        delete this.form.model.$promise;
        delete this.form.model.$resolved;

        if (confirmed) {
            uploadUrl += '&confirmUpdate=true';
        }

        this.Upload
            .upload({
                url: uploadUrl,
                data: this.form.model,
                method
            })
            .then((model) => {
                this.chosenFile = null;
                this.chosenFiles = [];
                this.chosenVideoFile = null;
                this.chosenVideoFiles = [];
                this.form.model.imageFile = null;
                if (this.form.model.questionAnswers) {
                    this.form.model.questionAnswers = this.form.model.questionAnswers.map(answer => {
                        answer.imageFile = null;
                        answer.removeImage = false;
                        return answer;
                    });
                }

                this.question = model.data;
                this.form.model = new this.QuestionResource(model.data);
                if (this.form.model.questionPoolId) {
                    this.form.model.questionPoolId = this.form.model.questionPoolId.toString();
                }
                this.$onInit();
                this.toastr.success(this.$translate.instant('question.Question is updated successfully'));

                if (parseInt(this.$state.params.id, 10) !== this.question.id) {
                    if (this.$state.params.poolId) {
                        this.$state.go(
                            'authorized.forms.questions.pools.question',
                            { poolId: this.$state.params.poolId, id: model.data.id }
                        );
                    }
                    else if (this.$state.includes('authorized.forms.questions.poolless')) {
                        this.$state.go('authorized.forms.questions.poolless.question', { id: model.data.id });
                    }
                    else if (this.$state.includes('authorized.forms.questions.all')) {
                        this.$state.go('authorized.forms.questions.all.question', { id: model.data.id });
                    }
                }
                this.tab = 'general';
            }).catch(response => {
                this.form.errors = this.ResponseService.parseErrors(response);
                this.handleResponse(response);
            });
    }

    handleResponse (response) {
        const msg = this.QuestionConfirmService.getConfirmationMessage(response);
        if (msg) {
            this.form.cleanErrors();
            this.ModalService.confirm(msg, 'medium').then(() => this.save(true));
            return;
        }

        this.detectTheTab(response);
    }

    detectTheTab (response) {
        const generalTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionPoolId' ||
                item.field === 'questionSiteIds' ||
                item.field === 'externalId' ||
                item.field === 'categoryId' ||
                item.field === 'questionI18n' ||
                item.field === 'country' ||
                item.field === 'name' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'description' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'language' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'help' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'timeToAnswer' ||
                item.field === 'level' ||
                item.field === 'imageFile' && (!item.path || !item.path.startsWith('questionAnswers')) ||
                item.field === 'videoFile' && (!item.path || !item.path.startsWith('questionAnswers')) ||
                item.field === 'videoUrl' && (!item.path || !item.path.startsWith('questionAnswers'))
                ;
        });
        const answerTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionAnswers' ||
                item.field === 'type' ||
                item.field === 'name' && item.path && this.lodash.includes(item.path, 'childQuestions') ||
                item.field === 'text' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'points' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'correctness' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'imageFile' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'videoFile' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'videoUrl' && item.path && this.lodash.includes(item.path, 'questionAnswers')
                ;
        });
        const metaTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionMetaFieldGroupId' ||
                item.field === 'metaFieldId' && item.path && this.lodash.includes(item.path, 'questionMeta') ||
                item.field === 'metaFieldValueId' && item.path && this.lodash.includes(item.path.includes, 'questionMeta') ||
                item.field === 'value' && item.path && this.lodash.includes(item.path, 'questionMeta')
                ;
        });

        if (generalTabFields && generalTabFields.message) {
            this.tab = 'general';
            return;
        }
        if (answerTabFields && answerTabFields.message) {
            this.tab = 'answers';
            return;
        }
        if (metaTabFields && metaTabFields.message) {
            this.tab = 'additional-settings';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/update/index.js